import {
  // Lesson Templates
  IntroductionVideoSchema,
  ObjectivesSchema,
  SceneSetterSchema,
  TerminologyReviewSchema,
  ReadingSchema,
  ListeningSchema,
  ReadingComprehensionSchema,
  ConceptCategorizingSchema,
  ErrorIdentificationSchema,
  SummaryEvaluationSchema,
  LinguisticEvaluationSchema,
  RegisterAnalysisSchema,
  LessonSummarySchema,
  ModuleSummarySchema,
  EnrichmentSchema,
  // PE Templates
  PETransitionSchema,
  MissionSelectionSchema,
  PEBriefSchema,
  LPEEnvironmentSchema,
  FPEEnvironmentHomeSchema,
  FPEEnvironmentPathSchema,
  PEReadingAuthenticMaterialSchema,
  PEListeningAuthenticMaterialSchema,
  PEReferenceReadingSchema,
  PEReferenceListeningSchema,
  PEMultipleChoiceSchema,
  PEConceptComprehensionSchema,
  PESupplementalContentSchema,
  FPEInformativeEventSchema,
  FPEDecisionEventSchema,
  FPEObservationEventSchema,
  PEDialogInteractionSchema,
  PEPhoneCallInteractionSchema,
  PEFaceToFaceInteractionSchema,
  PEFeedbackEventSchema,
  PEConstructedResponseSchema,
  PEConstructedDraftReportSchema,
  PEHypothesisResponseSchema,
  PEPresentationBriefSchema,
  PEArgumentCounterArgumentSchema,
  PEWhitePaperSchema,
  PENoteCardsSchema,
  PEOpEdPaperSchema,
  FPECapstoneReportSchema,
  PEDebriefSchema,
  // Assessment Templates
  AssessmentIntroductionScreenSchema,
  AssessmentListeningMultipleChoiceSchema,
  AssessmentReadingMultipleChoiceSchema,
  AssessmentSummaryScreenSchema,
  // Introductory Templates
  IntroCarouselSchema,
  TutorialVideoSchema,
  IntroSummarySchema
} from './Schemas';

const TemplateSchemas = {
  // Lesson Templates
  TMPL001: IntroductionVideoSchema,
  TMPL002: ObjectivesSchema,
  TMPL003: SceneSetterSchema,
  TMPL004: TerminologyReviewSchema,
  TMPL005: ReadingSchema,
  TMPL006: ListeningSchema,
  TMPL007: ReadingComprehensionSchema,
  TMPL008: ConceptCategorizingSchema,
  TMPL009: ErrorIdentificationSchema,
  TMPL010: SummaryEvaluationSchema,
  TMPL011: LinguisticEvaluationSchema,
  TMPL012: RegisterAnalysisSchema,
  TMPL013: LessonSummarySchema,
  TMPL014: ModuleSummarySchema,
  TMPL015: EnrichmentSchema,
  // PE Templates
  TMPPE001: PETransitionSchema,
  TMPPE002: MissionSelectionSchema,
  TMPPE003: PEBriefSchema,
  TMPPE004: LPEEnvironmentSchema,
  TMPPE005: FPEEnvironmentHomeSchema,
  TMPPE006: FPEEnvironmentPathSchema,
  TMPPE007: PEReadingAuthenticMaterialSchema,
  TMPPE008: PEListeningAuthenticMaterialSchema,
  TMPPE009: PEReferenceReadingSchema,
  TMPPE010: PEReferenceListeningSchema,
  TMPPE011: PEMultipleChoiceSchema,
  TMPPE012: PEConceptComprehensionSchema,
  TMPPE013: PESupplementalContentSchema,
  TMPPE014: FPEInformativeEventSchema,
  TMPPE015: FPEDecisionEventSchema,
  TMPPE016: FPEObservationEventSchema,
  TMPPE017: PEDialogInteractionSchema,
  TMPPE018: PEPhoneCallInteractionSchema,
  TMPPE019: PEFaceToFaceInteractionSchema,
  TMPPE020: PEFeedbackEventSchema,
  TMPPE021: PEConstructedResponseSchema,
  TMPPE022: PEConstructedDraftReportSchema,
  TMPPE023: PEHypothesisResponseSchema,
  TMPPE024: PEPresentationBriefSchema,
  TMPPE025: PEArgumentCounterArgumentSchema,
  TMPPE026: PEWhitePaperSchema,
  TMPPE027: PENoteCardsSchema,
  TMPPE028: PEOpEdPaperSchema,
  TMPPE029: FPECapstoneReportSchema,
  TMPPE030: PEDebriefSchema,
  // Assessment Templates
  TMPA001: AssessmentIntroductionScreenSchema,
  TMPA002: AssessmentReadingMultipleChoiceSchema,
  TMPA003: AssessmentListeningMultipleChoiceSchema,
  TMPA004: AssessmentSummaryScreenSchema,
  // Introductory Templates
  TMPI001: IntroCarouselSchema,
  TMPI002: TutorialVideoSchema, // Tutorial Video
  TMPI003: IntroSummarySchema
};

export default TemplateSchemas;
